import { Platform } from 'react-native';

import { logger } from 'utils/logger';
import { LottiePreparationMode } from 'utils/lottie/dotlottie-types';

const EVENT_NAME = 'loyalty_badge_animation';

const sharedContext = ({
  assetIdentifier,
  preparationMode,
  retryCount,
}: {
  assetIdentifier?: string;
  preparationMode: LottiePreparationMode;
  retryCount: number;
}) => ({
  event: EVENT_NAME,
  platform: Platform.OS,
  archiveFormat: 'dotlottie',
  assetIdentifier,
  preparationMode,
  retryCount,
});

export const logBadgeAnimationRendererFailure = ({
  assetIdentifier,
  preparationMode,
  retryCount,
}: {
  assetIdentifier?: string;
  preparationMode: LottiePreparationMode;
  retryCount: number;
}) => {
  logger.error({
    message: 'Loyalty badge animation renderer failed',
    ...sharedContext({ assetIdentifier, preparationMode, retryCount }),
    transition: 'renderer_failure',
    failureStage: 'renderer',
  });
};

export const logBadgeAnimationPlaybackCompletion = ({
  assetIdentifier,
  preparationMode,
  retryCount,
}: {
  assetIdentifier?: string;
  preparationMode: LottiePreparationMode;
  retryCount: number;
}) => {
  logger.info({
    message: 'Loyalty badge animation playback completed',
    ...sharedContext({ assetIdentifier, preparationMode, retryCount }),
    transition: 'playback_completion',
  });
};
